import {createSvgIcon} from '../create-svg-icon';

export const KeyboardOptionKeyIcon = createSvgIcon(
  <path d="M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z" />
, 'KeyboardOptionKeyOutlined');
